/* House of Dynast V7 on Horizon: size guard, size-guide dialog, outfit builder, colour legend sync, free-shipping bar. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Size guard: no size is chosen for the shopper ---------- */
  const isProduct = !!document.querySelector('variant-picker');
  const urlHasVariant = new URLSearchParams(location.search).has('variant');
  let needsSize = false;

  function sizeFieldset() {
    return $$('variant-picker fieldset').find((f) => {
      const l = f.querySelector('legend');
      return l && /^\s*size/i.test(l.textContent);
    });
  }
  function applyGuard() {
    const fs = sizeFieldset();
    if (!fs) return;
    if (fs.classList.contains('hod-size-unset') !== needsSize) fs.classList.toggle('hod-size-unset', needsSize);
    if (document.body.classList.contains('hod-needs-size') !== needsSize) document.body.classList.toggle('hod-needs-size', needsSize);
    if (needsSize) {
      const leg = fs.querySelector('legend');
      const val = leg && leg.querySelector('.variant-option__swatch-value');
      if (val && val.textContent !== 'Choose a size') val.textContent = 'Choose a size';
      if (leg && !val && !leg.querySelector('.hod-choose')) {
        const s = document.createElement('span');
        s.className = 'hod-choose variant-option__swatch-value';
        s.textContent = 'Choose a size';
        leg.appendChild(s);
      }
    } else {
      $$('.hod-choose').forEach((n) => n.remove());
      const leg = fs.querySelector('legend .variant-option__swatch-value');
      const chk = fs.querySelector('input:checked');
      if (leg && chk && leg.textContent !== chk.value) leg.textContent = chk.value;
      $$('.hod-size-msg').forEach((n) => n.remove());
    }
  }
  function showSizeError() {
    const fs = sizeFieldset();
    if (!fs) return;
    let m = fs.parentElement.querySelector('.hod-size-msg');
    if (!m) {
      m = document.createElement('p');
      m.className = 'hod-size-msg';
      m.setAttribute('role', 'alert');
      fs.insertAdjacentElement('afterend', m);
    }
    m.textContent = 'Please choose a size before adding to cart.';
    fs.scrollIntoView({ block: 'center' });
    const first = fs.querySelector('input:not([disabled])') || fs.querySelector('input');
    if (first) first.focus({ preventScroll: true });
  }
  if (isProduct && !urlHasVariant && sizeFieldset()) {
    needsSize = true;
    applyGuard();
    document.addEventListener('click', (e) => {
      const fs = sizeFieldset();
      if (needsSize && fs && fs.contains(e.target) && e.target.closest('label, input')) {
        needsSize = false;
        applyGuard();
      }
    }, true);
    document.addEventListener('keydown', (e) => {
      const fs = sizeFieldset();
      if (needsSize && fs && fs.contains(e.target) && (e.key.startsWith('Arrow') || e.key === ' ' || e.key === 'Enter')) {
        needsSize = false;
        applyGuard();
      }
    }, true);
    const block = (e) => {
      if (!needsSize) return;
      const t = e.target;
      const isAdd = e.type === 'submit'
        ? !!t.closest('product-form-component, form[action*="/cart/add"]')
        : !!t.closest('[ref="addToCartButton"], .sticky-add-to-cart button, sticky-add-to-cart button, button[name="add"]');
      if (!isAdd) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      showSizeError();
    };
    window.addEventListener('click', block, true);
    window.addEventListener('submit', block, true);
    let q = false;
    const mo = new MutationObserver(() => { if (!needsSize || q) return; q = true; setTimeout(() => { q = false; applyGuard(); }, 20); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Size guide dialog ---------- */
  function ensureDialog() {
    let d = $('#hodSizeDlg');
    if (d) return d;
    d = document.createElement('dialog');
    d.id = 'hodSizeDlg';
    d.className = 'hod-dlg';
    d.setAttribute('aria-labelledby', 'hodSizeTitle');
    d.innerHTML = '<div class="hod-dlg__hd"><h2 id="hodSizeTitle">Size Guide (CM)</h2><button type="button" class="hod-dlg__x" aria-label="Close size guide">×</button></div><div class="hod-dlg__bd"></div>';
    d.querySelector('.hod-dlg__x').addEventListener('click', () => d.close());
    d.addEventListener('click', (e) => { if (e.target === d) d.close(); });
    document.body.appendChild(d);
    return d;
  }
  function toInch(txt) {
    return txt.replace(/\d+(?:\.\d+)?/g, (n) => (Math.round((parseFloat(n) / 2.54) * 10) / 10).toString());
  }
  function openGuide(btn) {
    const src = (btn.dataset.source && document.querySelector(btn.dataset.source)) || document.querySelector('[id^="hod-sg-"] table, .hod-sg-source table') ||
      $$('.product-details table, product-description table, .rte table, [class*="description"] table')[0];
    const d = ensureDialog();
    const bd = d.querySelector('.hod-dlg__bd');
    const fit = btn.dataset.fit || '';
    if (!src) {
      bd.innerHTML = '<p>A size chart for this piece is not available yet. Email <a href="mailto:team@houseofdynast.shop">team@houseofdynast.shop</a> with your height and chest measurement and we will tell you which size to choose.</p>';
    } else {
      const t = src.cloneNode(true);
      t.removeAttribute('style');
      t.removeAttribute('class');
      $$('[style]', t).forEach((n) => n.removeAttribute('style'));
      const cm = $$('td,th', t).map((c) => c.innerHTML);
      bd.innerHTML = '<div class="hod-unit" role="group" aria-label="Units"><button type="button" aria-pressed="true" data-u="cm">cm</button><button type="button" aria-pressed="false" data-u="in">inches</button></div><div class="hod-tablewrap"></div>' + (fit ? '<p class="hod-fit">' + fit + '</p>' : '');
      bd.querySelector('.hod-tablewrap').appendChild(t);
      const cells = $$('td,th', t);
      const rows = $$('tr', t);
      if (!needsSize) {
        const fs = sizeFieldset();
        const v = fs && fs.querySelector('input:checked');
        if (v) rows.forEach((r) => { const c = r.cells[0]; if (c && c.textContent.trim().toUpperCase() === v.value.trim().toUpperCase()) r.classList.add('is-hl'); });
      }
      bd.querySelectorAll('.hod-unit button').forEach((b) => b.addEventListener('click', () => {
        const inch = b.dataset.u === 'in';
        bd.querySelectorAll('.hod-unit button').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        d.querySelector('#hodSizeTitle').textContent = inch ? 'Size Guide (inches)' : 'Size Guide (CM)';
        cells.forEach((c, i) => {
          const isFirstCol = c.cellIndex === 0;
          const isHead = c.closest('thead') || c.tagName === 'TH' || c.parentElement === rows[0];
          c.innerHTML = (inch && !isFirstCol && !isHead) ? toInch(cm[i]) : cm[i];
          if (isHead && inch) c.innerHTML = cm[i].replace(/\(?\s*cm\s*\)?/ig, '(in)');
        });
      }));
    }
    d.showModal();
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-hod-size-guide]');
    if (b) { e.preventDefault(); openGuide(b); }
  });

  /* ---------- Outfit builder ---------- */
  const money = (c, fmt) => {
    const v = (c / 100).toFixed(2).replace(/\.00$/, '');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
  };
  $$('[data-hod-builder]').forEach((root) => {
    let data;
    try { data = JSON.parse(root.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
    const fmt = root.dataset.money;
    const err = root.querySelector('.hod-err');
    const btn = root.querySelector('[data-hod-add]');
    const sumBox = root.querySelector('[data-hod-sum]');

    function state() {
      return data.pieces.map((p) => {
        const el = root.querySelector('[data-piece="' + p.key + '"]');
        const on = el.querySelector('[data-on]') ? el.querySelector('[data-on]').checked : true;
        const opts = p.options.map((_, i) => { const c = el.querySelector('input[name="' + p.key + '-o' + i + '"]:checked'); return c ? c.value : null; });
        const variant = opts.every(Boolean) ? p.variants.find((v) => v.options.every((o, i) => o === opts[i])) : null;
        return { p, el, on, opts, variant };
      });
    }
    function render() {
      const st = state();
      let total = 0, lines = '';
      st.forEach((s) => {
        s.el.classList.toggle('is-off', !s.on);
        s.p.options.forEach((_, i) => {
          root.querySelectorAll('input[name="' + s.p.key + '-o' + i + '"]').forEach((inp) => {
            const ok = s.p.variants.some((v) => v.available && v.options[i] === inp.value && v.options.every((o, j) => j === i || !s.opts[j] || o === s.opts[j]));
            inp.disabled = !ok;
          });
        });
        if (!s.on) return;
        const partial = s.p.variants.filter((v) => v.options.every((o, j) => !s.opts[j] || o === s.opts[j]));
        const price = s.variant ? s.variant.price : (partial.length ? Math.min(...partial.map((v) => v.price)) : s.p.from);
        total += price;
        lines += '<div class="hod-sumrow"><span>' + s.p.title + (s.variant ? ' · ' + s.variant.options.filter((o) => o !== 'Default Title').map((o) => o.split(' $')[0]).join(' / ') : '') + '</span><b>' + (s.variant ? '' : 'from ') + money(price, fmt) + '</b></div>';
      });
      const n = st.filter((s) => s.on).length;
      sumBox.innerHTML = (lines || '<p class="hod-note">Choose at least one piece.</p>') + (n ? '<div class="hod-sumrow hod-sumrow--tot"><span>Total</span><b>' + money(total, fmt) + '</b></div>' : '');
      btn.disabled = n === 0;
    }
    root.addEventListener('change', () => { err.textContent = ''; render(); });
    btn.addEventListener('click', async () => {
      const st = state().filter((s) => s.on);
      const missing = st.find((s) => !s.variant);
      if (missing) {
        const idx = missing.opts.findIndex((o) => !o);
        err.textContent = 'Choose a ' + (missing.p.options[idx] || 'option').toLowerCase() + ' for the ' + missing.p.title + '.';
        const f = missing.el.querySelectorAll('fieldset')[idx];
        if (f) { f.scrollIntoView({ block: 'center' }); const i = f.querySelector('input:not([disabled])'); if (i) i.focus({ preventScroll: true }); }
        return;
      }
      const sold = st.find((s) => !s.variant.available);
      if (sold) { err.textContent = 'That combination is sold out. Please choose another.'; return; }
      btn.disabled = true;
      const label = btn.textContent;
      btn.textContent = 'Adding…';
      const root0 = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      try {
        const r = await fetch(root0 + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: st.map((s) => ({ id: s.variant.id, quantity: 1 })) })
        });
        if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || 'Could not add to cart.'); }
        const drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          try {
            const [html, cartJson] = await Promise.all([
              fetch(root0 + '?section_id=cart-drawer-section').then((x) => x.text()),
              fetch(root0 + 'cart.js', { headers: { Accept: 'application/json' } }).then((x) => x.json())
            ]);
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('.cart-drawer__inner');
            const cur = drawer.querySelector('.cart-drawer__inner');
            if (fresh && cur) cur.replaceWith(document.importNode(fresh, true));
            document.querySelectorAll('cart-icon').forEach((ci) => { if (typeof ci.renderCartBubble === 'function') ci.renderCartBubble(cartJson.item_count); });
            btn.disabled = false;
            btn.textContent = label;
            drawer.open();
            return;
          } catch (e3) { /* fall through to the cart page */ }
        }
        location.href = root0 + 'cart';
      } catch (e2) {
        err.textContent = e2.message;
        btn.disabled = false;
        btn.textContent = label;
      }
    });
    render();
  });

  /* ---------- Option legends show the chosen value (V7: "Colour  Coffee") ---------- */
  document.addEventListener('change', (e) => {
    const fs = e.target.closest && e.target.closest('variant-picker fieldset');
    if (!fs) return;
    const v = fs.querySelector('legend .variant-option__swatch-value');
    if (v && !fs.classList.contains('hod-size-unset')) v.textContent = e.target.value;
  });

  /* ---------- Free-shipping progress in the cart drawer and cart page (V7) ---------- */
  const FREE = (window.HOD && window.HOD.freeShip) || 10000;
  const rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
  const fmtMoney = (c) => '$' + (c / 100).toFixed(2).replace(/\.00$/, '');
  let shipBusy = false;
  async function shipBar() {
    const hosts = $$('.cart-drawer__summary, .cart-page__summary, .cart__summary-totals');
    if (!hosts.length || shipBusy) return;
    shipBusy = true;
    try {
      const cart = await fetch(((window.Shopify && Shopify.routes) ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const goal = Math.round(FREE * rate);
      const left = Math.max(0, goal - cart.total_price);
      const txt = left > 0 ? 'Add ' + fmtMoney(left) + ' more for free shipping.' : 'Your order ships free.';
      const pct = Math.min(1, cart.total_price / goal);
      hosts.forEach((h) => {
        if (h.closest('.cart-drawer--empty')) return;
        let el = h.querySelector(':scope > .hod-ship');
        if (!el) { el = document.createElement('div'); el.className = 'hod-ship'; el.innerHTML = '<p></p><div class="hod-ship__bar" aria-hidden="true"><i></i></div>'; h.prepend(el); }
        const p = el.querySelector('p'); if (p.textContent !== txt) p.textContent = txt;
        const i = el.querySelector('i'); const t = 'scaleX(' + pct.toFixed(3) + ')'; if (i.style.transform !== t) i.style.transform = t;
      });
    } catch (e) { /* the bar is optional */ }
    shipBusy = false;
  }
  let shipQ = false;
  const shipLater = () => { if (shipQ) return; shipQ = true; setTimeout(() => { shipQ = false; shipBar(); }, 250); };
  const watch = (el) => { if (el) new MutationObserver((recs) => { if (recs.some((r) => !(r.target.closest && r.target.closest('.hod-ship')))) shipLater(); }).observe(el, { childList: true, subtree: true }); };
  watch(document.getElementById('cart-drawer'));
  watch(document.querySelector('.cart-page, .main-cart, [id*="main-cart"], [id*="main_cart"]'));
  shipLater();
})();
